import { FormType } from "@/enums";
import {
  camelCaseFixIntakeForm,
  fetchBaseQueryWrapper,
} from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

const TAG_TYPES = {
  adminForms: "Admin Forms",
};

export const adminFormsApi = createApi({
  reducerPath: "adminFormsApi",
  baseQuery: fetchBaseQueryWrapper({ path: "admin/forms" }),
  tagTypes: [TAG_TYPES.adminForms],
  endpoints: (build) => ({
    getAdminForms: build.query({
      query: (productCategory) => `${productCategory || ""}`,
      transformResponse: (response) => {
        const state = { forms: {}, categories: {} };

        state.forms[FormType.Intake] = camelCaseFixIntakeForm(
          response.data[FormType.Intake]
        );
        state.categories = response.data.categories;
        return state;
      },
      providesTags: [TAG_TYPES.adminForms],
    }),
    getAdminFlatForms: build.query({
      query: (productCategory) => `${productCategory || ""}?flat=true`,
      transformResponse: ({ data: { forms, categories } }) => {
        const state = {};
        state.flatForms = forms;

        // TODO: Be be removed during Cosmos DB update
        state[FormType.Intake] = camelCaseFixIntakeForm(forms);

        state.categories = categories;
        return state;
      },
    }),
    getFormProperty: build.query({
      query: ({ form, id }) => `${form}/properties/${id}`,
      transformResponse: (response) => response.data,
    }),
    createFormProperty: build.mutation({
      query: ({ form, property, values }) => ({
        url: `${form}/properties`,
        method: "POST",
        body: { property, values },
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: [TAG_TYPES.adminForms],
    }),
    updateFormProperty: build.mutation({
      query: ({ form, property, values }) => ({
        url: `${form}/properties/${property.id}`,
        method: "PUT",
        body: { property, values },
      }),
      invalidatesTags: [TAG_TYPES.adminForms],
    }),
    reorderProperties: build.mutation({
      query: ({ form, order }) => ({
        url: `${form}/properties/order`,
        method: "PATCH",
        body: { order },
      }),
    }),
    deleteFormProperty: build.mutation({
      query: ({ form, property }) => ({
        url: `${form}/properties/${property.id}`,
        method: "DELETE",
      }),
      invalidatesTags: [TAG_TYPES.adminForms],
    }),
  }),
});

export const {
  useGetAdminFormsQuery,
  useGetAdminFlatFormsQuery,
  useGetFormPropertyQuery,
  useCreateFormPropertyMutation,
  useDeleteFormPropertyMutation,
  useReorderPropertiesMutation,
  useUpdateFormPropertyMutation,
} = adminFormsApi;
